import { render, staticRenderFns } from "./loginNew.vue?vue&type=template&id=55680522&scoped=true&"
import script from "./loginNew.vue?vue&type=script&lang=js&"
export * from "./loginNew.vue?vue&type=script&lang=js&"
import style0 from "./loginNew.vue?vue&type=style&index=0&id=55680522&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55680522",
  null
  
)

export default component.exports